import React from "react";
import { Link } from "react-router-dom";

const MakaluSVGLogo = ({ height = 58 }) => {
  const width = Math.round(height * (380 / 390));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="150 45 380 390"
      width={width}
      height={height}
    >
      <defs>
        <linearGradient id="bl_fA" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FFFDE8" }} />
          <stop offset="18%" style={{ stopColor: "#FFE066" }} />
          <stop offset="50%" style={{ stopColor: "#C8960C" }} />
          <stop offset="100%" style={{ stopColor: "#5A3A00" }} />
        </linearGradient>
        <linearGradient id="bl_fB" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FFD700" }} />
          <stop offset="40%" style={{ stopColor: "#A87000" }} />
          <stop offset="100%" style={{ stopColor: "#3A2200" }} />
        </linearGradient>
        <linearGradient id="bl_fC" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#4A3000" }} />
          <stop offset="100%" style={{ stopColor: "#100800" }} />
        </linearGradient>
        <linearGradient id="bl_fD" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#2A1800" }} />
          <stop offset="100%" style={{ stopColor: "#080400" }} />
        </linearGradient>
        <linearGradient id="bl_fE" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#8A6000" }} />
          <stop offset="100%" style={{ stopColor: "#1C0E00" }} />
        </linearGradient>
        <linearGradient id="bl_fV" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#1A1000" }} />
          <stop offset="100%" style={{ stopColor: "#050200" }} />
        </linearGradient>
        <linearGradient id="bl_eL" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FFFFFF", stopOpacity: 0.9 }} />
          <stop offset="30%" style={{ stopColor: "#FFE566", stopOpacity: 0.95 }} />
          <stop offset="70%" style={{ stopColor: "#C8960C", stopOpacity: 0.7 }} />
          <stop offset="100%" style={{ stopColor: "#7A5000", stopOpacity: 0.3 }} />
        </linearGradient>
        <linearGradient id="bl_gText" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#8A6000" }} />
          <stop offset="20%" style={{ stopColor: "#FFD700" }} />
          <stop offset="50%" style={{ stopColor: "#FFFDE8" }} />
          <stop offset="80%" style={{ stopColor: "#FFD700" }} />
          <stop offset="100%" style={{ stopColor: "#8A6000" }} />
        </linearGradient>
        <linearGradient id="bl_gLine" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#FFD700", stopOpacity: 0 }} />
          <stop offset="25%" style={{ stopColor: "#FFD700", stopOpacity: 0.5 }} />
          <stop offset="75%" style={{ stopColor: "#FFD700", stopOpacity: 0.5 }} />
          <stop offset="100%" style={{ stopColor: "#FFD700", stopOpacity: 0 }} />
        </linearGradient>
      </defs>

      {/* Mountain polygons */}
      <polygon points="168,242 252,55 218,112 190,172" fill="url(#bl_fA)" />
      <polygon points="168,242 252,55 285,130 235,175 205,215" fill="url(#bl_fB)" opacity="0.9" />
      <polygon points="252,55 312,175 295,190 275,148 255,90" fill="url(#bl_fC)" />
      <polygon points="168,242 205,215 235,175 280,195 312,242" fill="url(#bl_fE)" opacity="0.7" />
      <polygon points="312,175 340,210 368,175 340,195" fill="url(#bl_fV)" />
      <polygon points="295,190 312,175 340,210 368,175 385,190 340,220 295,190" fill="url(#bl_fD)" opacity="0.9" />
      <polygon points="428,55 368,175 385,190 405,148 425,90" fill="url(#bl_fC)" />
      <polygon points="512,242 428,55 395,130 445,175 475,215" fill="url(#bl_fB)" opacity="0.9" />
      <polygon points="512,242 428,55 462,112 490,172" fill="url(#bl_fA)" />
      <polygon points="512,242 475,215 445,175 400,195 368,242" fill="url(#bl_fE)" opacity="0.7" />

      {/* Edge lines */}
      <line x1="168" y1="242" x2="252" y2="55" stroke="url(#bl_eL)" strokeWidth="2" />
      <line x1="252" y1="55" x2="312" y2="175" stroke="#C8960C" strokeWidth="1" opacity="0.6" />
      <line x1="312" y1="175" x2="340" y2="210" stroke="#7A5000" strokeWidth="0.7" opacity="0.5" />
      <line x1="340" y1="210" x2="368" y2="175" stroke="#7A5000" strokeWidth="0.7" opacity="0.5" />
      <line x1="368" y1="175" x2="428" y2="55" stroke="#C8960C" strokeWidth="1" opacity="0.6" />
      <line x1="428" y1="55" x2="512" y2="242" stroke="url(#bl_eL)" strokeWidth="2" />
      <line x1="252" y1="55" x2="285" y2="130" stroke="#FFD700" strokeWidth="0.8" opacity="0.4" />
      <line x1="428" y1="55" x2="395" y2="130" stroke="#FFD700" strokeWidth="0.8" opacity="0.4" />

      {/* Decorative lines */}
      <line x1="155" y1="243" x2="525" y2="243" stroke="url(#bl_gLine)" strokeWidth="0.7" />
      <line x1="130" y1="272" x2="550" y2="272" stroke="url(#bl_gLine)" strokeWidth="0.5" />

      {/* MAKALU text */}
      <text
        x="340" y="336"
        textAnchor="middle"
        fontFamily="'Playfair Display','Didot','Georgia',serif"
        fontSize="60"
        fontWeight="700"
        letterSpacing="16"
        fill="url(#bl_gText)"
      >
        MAKALU
      </text>

      {/* Bottom line */}
      <line x1="165" y1="350" x2="515" y2="350" stroke="url(#bl_gLine)" strokeWidth="0.4" />

      {/* AGRO AND TRADE */}
      <text
        x="340" y="384"
        textAnchor="middle"
        fontFamily="'Trebuchet MS','Arial',sans-serif"
        fontSize="15"
        fontWeight="400"
        letterSpacing="9"
        fill="#FFD700"
      >
        AGRO  AND  TRADE
      </text>
    </svg>
  );
};

export { MakaluSVGLogo };

const BrandLogo = ({ isScrolled }) => {
  return (
    <Link to="/" className="flex items-center">
      <MakaluSVGLogo height={58} />
    </Link>
  );
};

export default BrandLogo;
